import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './commonjs/fontSize';
import './css/common.css';
import HomePage from './component/homePage';
import Type from './config/topicData';
import InputAddr from './component/inputAddr';
import AddrDetail from './component/addrDetail';
// import registerServiceWorker from './commonjs/registerServiceWorker';

import {
  Router,
  IndexRoute,
  Route,
} from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';

const history = createHistory();
class FirstPage extends Component {
    render(){
       let routeView = "";
       if(Type.drawType == "0"){
         routeView = <Route exact path="/" component={HomePage} />
       }
        return(
        	<Router history={history}>
	            <div>
                  {routeView}
                  <Route exact path="/addr" component={InputAddr} />
                  <Route exact path="/addrdet" component={AddrDetail} />
	            </div>
            </Router>
        )
    }
}

ReactDOM.render(<FirstPage />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js